import { IconButton as MuiIconButton, type IconButtonProps as MuiIconButtonProps } from '@mui/material'
import { type SystemCssProperties } from '@dhl-ui/theme'
import { type BaseProps } from '../../types'

type BaseColor = 'primary' | 'error' | 'info' | 'success' | 'dark' | 'inherit' | 'alternative'

export type IconButtonProps = BaseProps<
  HTMLButtonElement,
  never,
  Pick<SystemCssProperties, 'position' | 'top' | 'left' | 'right' | 'bottom'>
> &
  Omit<MuiIconButtonProps, 'sx' | 'className' | 'color'> & {
    variant?: 'outlined' | 'ghost' | 'contained'
    square?: boolean
    color?: BaseColor
    title?: string
    'aria-label': string
  }
export const IconButton = ({ children, sx, square, ...props }: IconButtonProps) => (
  <MuiIconButton disableRipple {...props} sx={sx} {...(square ? { className: 'DhlIconButton-square' } : {})}>
    {children}
  </MuiIconButton>
)
